import $ from 'jquery';
import VisSenseFactory from 'vissense';

$(() => {

    if ($('.js-vissense').length) {
        const VisSense = VisSenseFactory(window);

        $('.js-vissense').each(function (index) {
            var vissenseContainer = $(this);
            var vissenseVisibility = VisSense(vissenseContainer[0], {
                fullyvisible: 0.5
            });
            vissenseVisibility.monitor({
                fullyvisible: function () {
                    vissenseContainer.addClass('on-screen')
                },
                hidden: function () {
                    vissenseContainer.removeClass("on-screen");
                },
            })
                .start();


        });
    }


});